import { BRAND } from '../config/brand'
export default {
  common: {
    appName: BRAND.fullProductName,
    appDescription: 'Integrated Construction Project Management System',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    viewAll: 'View All',
    noData: 'No data',
    error: 'An error occurred',
    success: 'Success',
    required: 'Required',
    optional: 'Optional',
    clearFilter: 'Clear filter',
    all: 'All',
  },

  nav: {
    dashboard: 'Dashboard',
    projects: 'Projects',
    companies: 'Companies',
    clients: 'Clients',
    consultants: 'Consultants',
    suppliers: 'Suppliers',
    team: 'Team',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
 reports: 'Reports',
    portfolio: 'Portfolio',
    overheadPool: 'Overhead Pool',
  },

  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    username: 'Username',
    phone: 'Phone',
    company: 'Company',
    role: 'Role',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    loginButton: 'Login',
    registerButton: 'Create Account',
    loggingIn: 'Logging in...',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    welcomeBack: 'Welcome Back',
    invalidCredentials: 'Invalid email or password',
  },

  dashboard: {
    welcome: 'Welcome',
    overview: `Overview of your activity in ${BRAND.fullProductName}`,
    totalCompanies: 'Companies',
    totalProjects: 'Projects',
    activeProjects: 'Active Projects',
    contractValue: 'Contract Value',
    actualCost: 'Actual Cost',
    paidAmount: 'Paid Amount',
    boqSections: 'BOQ Sections',
    boqValue: 'BOQ Value',
    recentProjects: 'Recent Projects',
    projectsByStatus: 'Projects by Status',
    projectsByType: 'Projects by Type',
    projectsProgress: 'Projects Progress',
    noProjects: 'No projects yet',
  },

  projects: {
    title: 'Projects',
    newProject: 'New Project',
    projectCount: '{{count}} project(s)',
    searchPlaceholder: 'Search by name or code...',
    noProjects: 'No projects found',
    startCreating: 'Start by creating your first project',
    code: 'Project Code',
    name: 'Project Name',
    nameAr: 'Arabic Name',
    type: 'Type',
    status: 'Status',
    priority: 'Priority',
    client: 'Client',
    consultant: 'Consultant',
    location: 'Location',
    city: 'City',
    country: 'Country',
    plotNumber: 'Plot Number',
    contractDate: 'Contract Date',
    startDate: 'Start Date',
    plannedEndDate: 'Planned End Date',
    actualEndDate: 'Actual End Date',
    duration: 'Duration (days)',
    contractValue: 'Contract Value',
    actualCost: 'Actual Cost',
    paidAmount: 'Paid Amount',
    currency: 'Currency',
    progress: 'Progress',
    description: 'Description',
    scopeOfWork: 'Scope of Work',
    notes: 'Notes',
    statuses: {
      planning: 'Planning',
      tendering: 'Tendering',
      awarded: 'Awarded',
      active: 'Active',
      on_hold: 'On Hold',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    types: {
      residential: 'Residential',
      commercial: 'Commercial',
      industrial: 'Industrial',
      infrastructure: 'Infrastructure',
      hospitality: 'Hospitality',
      healthcare: 'Healthcare',
      educational: 'Educational',
      religious: 'Religious',
      mixed_use: 'Mixed Use',
      renovation: 'Renovation',
      other: 'Other',
    },
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
    },
  },

  projectDetails: {
    backToProjects: 'Back to Projects',
    overview: 'Overview',
    info: 'Information',
    boq: 'Bill of Quantities',
    import: 'Import BOQ',
    team: 'Team',
    documents: 'Documents',
    downloadVariance: 'Variance Report',
    generating: 'Generating...',
    downloadVarianceError: 'Failed to download report. Please try again.',
    openBoq: 'Open BOQ',
    openFullBoq: 'Open Full BOQ',
    timeline: 'Timeline',
    location: 'Location',
    basicInfo: 'Basic Information',
    parties: 'Parties',
    boqValue: 'BOQ Value',
    notFound: 'Project not found',
    teamComingSoon: 'Team Management - Coming Soon',
    documentsComingSoon: 'Document Management - Coming Soon',

    // Sprint 3 Apex W2-J mirror tabs.
    qto: 'QTO from Drawings',
    estimation: 'Estimation',
    materials: 'Materials',
    costComparison: 'Cost Comparison',
    qtoMissingProject: 'No project loaded — QTO workspace unavailable.',
    estimationMissingProject: 'No project loaded — Estimation grid unavailable.',
    materialsTitle: 'Project Materials (BOM)',
    materialsSubtitle:
      'Pin BOM items to this project. Locked rates feed the Estimation grid and Cost Comparison.',
    materialsAdd: 'Add material',
    materialsEmptyTitle: 'No materials locked to this project yet',
    materialsEmptyHint: 'Use “Add material” to pick from the BOM catalogue.',
    materialsRemove: 'Remove material from project',
    materialsCol: {
      code: 'Code',
      name: 'Name',
      unit: 'Unit',
      lockedRate: 'Locked rate',
      source: 'Price source',
      actions: 'Actions',
    },
    costComparisonTitle: 'Estimated vs Actual',
    costComparisonSubtitle:
      'Variance traffic-light follows ORKSTRA standard thresholds. Click a section to drill in.',
    ccBreadcrumb: 'Cost comparison drill-down',
    ccBreadcrumbProject: 'Project',
    ccBreadcrumbSection: 'Section',
    ccBreadcrumbItem: 'Item',
  },

  companies: {
    title: 'Companies',
    newCompany: 'New Company',
    companyCount: '{{count}} compan(ies)',
    searchPlaceholder: 'Search by name or license...',
    noCompanies: 'No companies found',
    startCreating: 'Start by adding your first company',
    name: 'Company Name',
    nameAr: 'Arabic Name',
    type: 'Company Type',
    tradeLicense: 'Trade License',
    taxNumber: 'Tax Number',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    address: 'Address',
    city: 'City',
    country: 'Country',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account',
    iban: 'IBAN',
    description: 'Description',
    types: {
      contractor: 'Main Contractor',
      subcontractor: 'Subcontractor',
      consultant: 'Consultant',
      supplier: 'Supplier',
      client: 'Client',
    },
  },

  clients: {
    title: 'Clients',
    clientLabel: 'Client',
    clientCount: '{{count}} client(s)',
    searchPlaceholder: 'Search by name...',
    noClients: 'No clients found',
    clientsDerivedFromProjects: 'Clients are automatically derived from projects',
    clientNotFoundDescription: 'No client named "{{name}}" was found in any project',
    notFound: 'Client not found',
    backToClients: 'Back to Clients',
    projects: 'Projects',
    active: 'Active',
    completed: 'Completed',
    totalContractValue: 'Total Contract Value',
    projectsList: 'Projects List',
  },

  consultants: {
    title: 'Consultants',
    consultantLabel: 'Consultant',
    consultantCount: '{{count}} consultant(s)',
    searchPlaceholder: 'Search by name...',
    noConsultants: 'No consultants found',
    consultantsDerivedFromProjects: 'Consultants are automatically derived from projects',
    consultantNotFoundDescription: 'No consultant named "{{name}}" was found in any project',
    notFound: 'Consultant not found',
    backToConsultants: 'Back to Consultants',
    projects: 'Projects',
    active: 'Active',
    completed: 'Completed',
    totalContractValue: 'Total Contract Value',
    projectsList: 'Projects List',
  },

  boq: {
    title: 'Bill of Quantities',
    subtitle: 'BOQ',
    grandTotal: 'Grand Total',
    totalSections: 'Sections',
    totalItems: 'Items',
    addSection: 'Add Section',
    addItem: 'Add Item',
    editSection: 'Edit Section',
    editItem: 'Edit Item',
    sectionCode: 'Section Code',
    sectionName: 'Section Name',
    sectionNameAr: 'Arabic Name',
    itemCode: 'Item Code',
    description: 'Description',
    descriptionAr: 'Arabic Description',
    unit: 'Unit',
    quantity: 'Quantity',
    unitRate: 'Unit Rate',
    total: 'Total',
    isSubtotal: 'Heading only (no price)',
    displayOrder: 'Order',
    notes: 'Notes',
    specification: 'Specification',
    sectionTotal: 'Section Total',
    noSections: 'No sections in this project',
    addFirstSection: 'Start by adding the first section',
    noItems: 'No items',
    selectProject: 'Select a project',
    backToProjects: 'Back to Projects',
    export: 'Export to Excel',
    exporting: 'Exporting...',
    exportPdf: 'Export PDF',
    exportingPdf: 'Generating PDF...',
    import: 'Import from Excel',
    importing: 'Importing...',
    downloadTemplate: 'Download Template',
    uploadFile: 'Upload Excel File',
    importPreview: 'Import Preview',
    confirmImport: 'Confirm Import',
    importInstructions: 'Download the template, fill it with your data, then upload it',
    mapping: {
      searchPlaceholder: 'Search code, description, or unit…',
      filterAll: 'All',
      filterUnassigned: 'Unassigned',
      filterPartial: 'Partially mapped',
      filterComplete: 'Fully mapped',
      sortNone: 'Default order',
      sortLinked: 'Sort by linked',
      sortVariance: 'Sort by variance',
      selectUnassigned: 'Select unassigned',
      clearSelection: 'Clear selection',
      selectedCount: '{{count}} selected',
      bulkAutoSuggest: 'Auto-suggest mappings',
      bulkClear: 'Clear mappings',
      bulkRecalc: 'Recalculate rollup',
      linked: 'Linked',
      manualQty: 'Manual Qty',
      autoQty: 'Auto-Mapped Qty',
      variance: 'Variance',
      status: 'Status',
      status_unassigned: 'Unassigned',
      status_partial: 'Partial',
      status_complete: 'Complete',
      noMatches: 'No items match the current filters',
      pageSizeHint: 'Showing {{shown}} of {{total}} items',
    },
    units: {
      no: 'No.',
      m: 'm',
      m2: 'm²',
      m3: 'm³',
      kg: 'kg',
      ton: 'ton',
      lump: 'lump',
      lot: 'lot',
      hr: 'hour',
      day: 'day',
      ls: 'L.S.',
    },
  },

  profile: {
    title: 'Profile',
    subtitle: 'Manage your account information and settings',
    viewProfile: 'View Profile',
    personalInfo: 'Personal Information',
    accountInfo: 'Account Information',
    security: 'Security',
    memberSince: 'Member since',
    lastLogin: 'Last login',
    never: 'Never',
    active: 'Active',
    inactive: 'Inactive',
    verified: 'Verified',
    changePassword: 'Change Password',
    changePasswordDescription: 'Update your password regularly to keep your account secure',
    change: 'Change',
    changing: 'Changing...',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    passwordTooShort: 'Password must be at least 8 characters',
    samePassword: 'New password must be different from the current one',
    passwordMismatch: 'Passwords do not match',
    passwordChangedSuccess: 'Password changed successfully',
    passwordRequirements: 'At least 8 characters. Preferably mix uppercase, lowercase, numbers, and symbols',
    passwordSecurityTitle: 'Password Security',
    passwordSecurityHint: 'Use a strong password that you don\'t use elsewhere',
    passwordStrength: 'Password strength',
    passwordWeak: 'Weak',
    passwordMedium: 'Medium',
    passwordStrong: 'Strong',
  },

  team: {
    title: 'Team Management',
    subtitle: 'Manage users and permissions',
    userCount: '{{count}} user(s)',
    searchPlaceholder: 'Search by name or email...',
    newUser: 'New User',
    noUsers: 'No users found',
    startCreating: 'Start by adding team members',
    you: 'You',
    isActive: 'Active',
    isVerified: 'Verified',
    deactivate: 'Deactivate',
    deactivateUser: 'Deactivate User',
    deactivateConfirm: 'Are you sure you want to deactivate user',
    resetPassword: 'Reset Password',
    resetPasswordWarning: 'You are changing this user\'s password. You must share it with them securely.',
    resetPasswordHint: 'A new strong password. Share it with the user via a secure channel.',
    resetPasswordSuccess: 'Password reset successfully',
    userCreatedSuccess: 'User created successfully',
    userDeactivatedSuccess: 'User deactivated',
    accessDenied: 'Access Denied',
    adminOnlyAccess: 'This page is only accessible to system administrators',
    allRoles: 'All Roles',
    selectRole: '— Select a role —',
    currentRole: 'Current role',
    noRoleAssigned: 'No role assigned',
    rolesLoadFailed: 'Could not load the role list',
    roleNotInCatalogue: '(not in the role list)',
    roleNotInCatalogueHint:
      'This user holds a role that is not in the tenant role list. Saving keeps it unless you pick another.',
  },

  documents: {
    title: 'Documents',
    subtitle: 'Manage contracts, invoices, and photos',
    documentCount: '{{count}} document(s)',
    searchPlaceholder: 'Search by name or description...',
    uploadDocument: 'Upload Document',
    upload: 'Upload',
    uploading: 'Uploading...',
    uploadSuccess: 'Document uploaded successfully',
    deleteDocument: 'Delete Document',
    deleteConfirm: 'Are you sure you want to delete',
    deleteSuccess: 'Document deleted',
    download: 'Download',
    noDocuments: 'No documents yet',
    startUploading: 'Start by uploading documents for this project',
    documentName: 'Document Name',
    documentNameAr: 'Arabic Name',
    namePlaceholder: 'e.g., Construction Contract',
    nameArPlaceholder: 'e.g., عقد المقاولة',
    description: 'Description',
    descriptionPlaceholder: 'Optional description',
    category: 'Category',
    allCategories: 'All Categories',
    nameRequired: 'Document name is required',
    selectFile: 'Please select a file to upload',
    fileTooLarge: 'File size exceeds 10 MB limit',
    dragDropHint: 'Drag and drop file here',
    orClickToSelect: 'or click to select',
    maxFileSize: 'Max 10MB',
    supportedFormats: 'PDF, Word, Excel, images, DWG and more',
    categories: {
      contract: 'Contracts',
      invoice: 'Invoices',
      payment: 'Payments',
      drawing: 'Drawings',
      photo: 'Photos',
      report: 'Reports',
      permit: 'Permits',
      insurance: 'Insurance',
      boq: 'BOQ Files',
      specification: 'Specifications',
      correspondence: 'Correspondence',
      other: 'Other',
    },
  },

  forgotPassword: {
    title: 'Forgot Password?',
    subtitle: 'Enter your email and we\'ll send you a reset link',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: 'Back to Login',
    checkEmail: 'Check your email!',
    emailSentTo: 'We sent a reset link to:',
    nextSteps: 'Next steps:',
    step1: 'Open your email inbox',
    step2: `Look for an email from ${BRAND.fullProductName}`,
    step3: 'Click the "Reset Password" button',
    linkExpires: 'Link is valid for 60 minutes only',
  },

  resetPassword: {
    title: 'Reset Your Password',
    forAccount: 'For account:',
    resetButton: 'Confirm New Password',
    resetting: 'Resetting...',
    success: 'Password reset successfully!',
    invalidToken: 'Invalid or Expired Link',
    invalidTokenDesc: 'This reset link has expired or been used',
    noToken: 'Invalid Link',
    noTokenDesc: 'No reset token found in URL',
    requestNew: 'Request New Link',
  },
reports: {
  title: 'Reports & Analytics',
  subtitle: 'Comprehensive overview of project performance',
  totalProjects: 'Total Projects',
  totalValue: 'Total Value',
  active: 'active',
  contractsValue: 'Contracts value',
  teamMembers: 'Team Members',
  activeUsers: 'Active users',
  documents: 'Documents',
  allDocs: 'All documents',
  financialOverview: 'Financial Overview',
  totalRevenue: 'Total Revenue',
  totalCost: 'Total Cost',
  estimatedProfit: 'Estimated Profit',
  margin: 'profit margin',
  projectsBreakdown: 'Projects Breakdown',
  project: 'Project',
  contractValue: 'Contract Value',
  boqTotal: 'BOQ Total',
  profit: 'Profit',
  marginPct: 'Margin',
  projectsByStatus: 'Projects by Status',
},

  roles: {
    admin: 'Administrator',
    project_manager: 'Project Manager',
    engineer: 'Engineer',
    accountant: 'Accountant',
    viewer: 'Viewer',
  },

  portfolio: {
    title: 'Portfolio Dashboard',
    subtitle: 'Multi-project executive overview',
    refresh: 'Refresh',
    downloadPdf: 'Download Summary PDF',
    downloading: 'Generating PDF...',
    downloadError: 'Failed to download PDF. Please try again.',
    refreshing: 'Refreshing...',
    lastUpdated: 'Last updated',

    metrics: {
      activeProjects: 'Active Projects',
      activeProjectsHint: 'Currently in portfolio',
      totalContract: 'Total Contract Value',
      paid: 'paid',
      totalBac: 'Total BAC',
      weightedSpiCpi: 'Weighted SPI / CPI',
      avgProgress: 'Avg progress',
      trueCost: 'True Cost',
      marginTheoretical: 'Margin (Theoretical)',
      marginTheoreticalHint: 'Contract - True Cost',
      marginCollected: 'Margin (Collected)',
      marginCollectedHint: 'Paid - True Cost',
      weightedRisk: 'Weighted Risk Score',
      atRiskShort: 'at risk',
    },

    riskLevel: {
      healthy: 'Healthy',
      watch: 'Watch',
      at_risk: 'At Risk',
      critical: 'Critical',
    },

    riskDistribution: {
      title: 'Risk Distribution',
      filteredBy: 'Filtered by',
    },

    projects: {
      title: 'Projects',
    },

    project: {
      contract: 'Contract',
      bac: 'BAC',
      progress: 'Progress',
    },

    empty: {
      noProjects: 'No projects in portfolio yet',
    },

    modal: {
      financial: 'Financial Overview',
      performance: 'Performance',
      riskBreakdown: 'Risk Breakdown',
      scheduleRisk: 'Schedule Risk',
      costRisk: 'Cost Risk',
      criticalPathRisk: 'Critical Path Risk',
      liquidityRisk: 'Liquidity Risk',
      totalRisk: 'Total Risk Score',
      timeline: 'Timeline',
      startDate: 'Start Date',
      plannedEnd: 'Planned End',
      openProject: 'Open Project',
      computationError: 'Computation Error',
    },

        error: {
      loadFailed: 'Failed to load portfolio data. Please try refreshing.',
    },
  },

  overhead: {
    title: 'Overhead Pool',
    subtitle: 'Manage monthly overhead values for portfolio cost allocation',
    addEntry: 'Add Entry',
    addFirst: 'Add First Entry',
    grandTotal: 'Grand Total',
    byCategory: 'By Category',
    entries: 'Entries',
    
    form: {
      year: 'Year',
      month: 'Month',
      category: 'Category',
      amount: 'Amount',
      description: 'Description',
      descriptionPlaceholder: 'Optional notes about this entry...',
      editingHint: 'To change category/period, delete and create a new entry',
    },
    
    categories: {
      salaries: 'Salaries & Wages',
      office: 'Office Expenses',
      depreciation: 'Depreciation',
      software: 'Software & IT',
      insurance: 'Insurance',
      banking: 'Banking & Finance',
      professional: 'Professional Fees',
      other: 'Other',
    },
    
    modal: {
      addTitle: 'Add Overhead Entry',
      editTitle: 'Edit Overhead Entry',
    },
    
    empty: {
      noEntries: 'No overhead entries for this period yet.',
    },
    
    errors: {
      invalidAmount: 'Please enter a valid amount greater than zero',
      logoUploadSuccess: 'Logo uploaded successfully',
    logoDeleteSuccess: 'Logo removed successfully',
    saveFailed: 'Failed to save entry. Please try again.',
      loadFailed: 'Failed to load overhead data',
    },
  },

  settings: {
    title: 'Company Settings',
    subtitle: "Manage your company's branding, contact information, and legal details",
    branding: 'Branding',
    contact: 'Contact Information',
    legal: 'Legal Information',
    logo: 'Company Logo',
    logoEmpty: 'No logo uploaded yet. Upload a PNG, JPEG, or WebP image (max 2 MB).',
    logoCurrent: 'Current logo',
    logoUpload: 'Upload Logo',
    logoReplace: 'Replace',
    logoRemove: 'Remove',
    logoDeleteConfirm: 'Are you sure you want to remove the company logo?',
    logoUploadFailed: 'Logo upload failed. Please try again.',
    logoDeleteFailed: 'Logo removal failed. Please try again.',
    logoErrorType: 'Unsupported file type. Allowed: PNG, JPEG, WebP.',
    logoErrorSize: 'File too large. Maximum size is 2 MB.',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    addressEn: 'Address (English)',
    addressAr: 'Address (Arabic)',
    taxNumber: 'Tax Number',
    tradeLicense: 'Trade License Number',
    savedSuccess: 'Settings saved successfully',
    saveFailed: 'Failed to save settings',
    // S49: tenant display preferences
    displayPrefs: 'Display Preferences',
    calendarPreference: 'Calendar Preference',
    calendarGregorian: 'Gregorian only',
    calendarHijri: 'Hijri only',
    calendarBoth: 'Both (Gregorian + Hijri)',
    defaultCurrency: 'Default Currency',
    defaultCurrencyHint: 'Used as the fallback when a record has no explicit currency.',
  },

  // Module 2.3 — Document Management System
  dms: {
    title: 'Document Management',
    dashboard: 'DMS Dashboard',
    drawings: 'Drawings',
    submittals: 'Submittals',
    rfis: 'RFIs',
    transmittals: 'Transmittals',
    markups: 'PDF Markups',
    counters: {
      drawingsTotal: 'Drawings total',
      drawingsForConstruction: 'For construction',
      submittalsOpen: 'Open submittals',
      submittalsOverdue: 'Overdue submittals',
      rfisOpen: 'Open RFIs',
      rfisOverdue: 'Overdue RFIs',
      transmittalsThisMonth: 'Transmittals this month',
    },
    drawing: {
      number: 'Drawing No.',
      title: 'Title',
      discipline: 'Discipline',
      revision: 'Revision',
      revisions: 'Revisions',
      currentRevision: 'Current revision',
      uploadRevision: 'Upload revision',
      newDrawing: 'New drawing',
      uploadedAt: 'Uploaded',
      uploadedBy: 'Uploaded by',
      fileSize: 'File size',
      notes: 'Notes',
      empty: 'No drawings yet. Create one to start the register.',
    },
    submittal: {
      number: 'Submittal No.',
      subject: 'Subject',
      priority: 'Priority',
      submit: 'Submit',
      respond: 'Respond',
      close: 'Close',
      consultantDue: 'Consultant due',
      responseHistory: 'Response history',
      specSection: 'Spec section',
      newSubmittal: 'New submittal',
      empty: 'No submittals yet.',
    },
    rfi: {
      number: 'RFI No.',
      subject: 'Subject',
      question: 'Question',
      respond: 'Respond',
      close: 'Close',
      consultantDue: 'Consultant due',
      answeredAt: 'Answered at',
      newRfi: 'New RFI',
      empty: 'No RFIs yet.',
      isFinal: 'Mark as final answer',
      costImpact: 'Cost impact (AED)',
      scheduleImpact: 'Schedule impact (days)',
    },
    transmittal: {
      number: 'Transmittal No.',
      subject: 'Subject',
      purpose: 'Purpose',
      recipientCompany: 'Recipient',
      recipientEmails: 'Recipient emails',
      send: 'Send',
      acknowledge: 'Mark acknowledged',
      sentAt: 'Sent at',
      acknowledgedAt: 'Acknowledged at',
      items: 'Items',
      addItem: 'Add item',
      newTransmittal: 'New transmittal',
      empty: 'No transmittals yet.',
    },
    status: {
      draft: 'Draft',
      submitted: 'Submitted',
      reviewing: 'Reviewing',
      approved: 'Approved',
      approved_with_comments: 'Approved with comments',
      rejected: 'Rejected',
      resubmit_required: 'Resubmit required',
      closed: 'Closed',
      open: 'Open',
      answered: 'Answered',
      void: 'Void',
      sent: 'Sent',
      acknowledged: 'Acknowledged',
      for_construction: 'For construction',
      superseded: 'Superseded',
      archived: 'Archived',
    },
    priority: {
      low: 'Low',
      normal: 'Normal',
      high: 'High',
      urgent: 'Urgent',
    },
    purpose: {
      for_information: 'For information',
      for_review: 'For review',
      for_approval: 'For approval',
      for_construction: 'For construction',
    },
    activity: {
      drawing_uploaded: 'Drawing uploaded',
      submittal_submitted: 'Submittal submitted',
      submittal_responded: 'Submittal answered',
      rfi_asked: 'RFI asked',
      rfi_answered: 'RFI answered',
      transmittal_sent: 'Transmittal sent',
    },
    common: {
      noProject: 'Select a project to view DMS data.',
      loading: 'Loading…',
      saved: 'Saved',
      saveFailed: 'Save failed',
    },
  },

  // === AGENT_A (M2.8 Workforce + Payroll) BEGIN ===
  workforce: {
    nav: 'Workforce',
    backToList: 'Back to list',
    hiredOn: 'Hired',
    employees: {
      title: 'Employees',
      count: '{{count}} employee(s)',
      searchPlaceholder: 'Search by name, code, or Emirates ID…',
      new: 'New Employee',
      empty: 'No employees found',
      emptyHint: 'Start by onboarding your first employee.',
    },
    departments: {
      title: 'Departments',
      count: '{{count}} department(s)',
      empty: 'No departments yet',
    },
    leave: {
      title: 'Leave Requests',
      subtitle: '{{count}} request(s) on this view',
      empty: 'No leave requests',
      employee: 'Employee',
      days: 'days',
      approve: 'Approve',
      reject: 'Reject',
      rejectTitle: 'Reject Leave Request',
      rejectPrompt: 'Provide a reason for rejection (optional).',
      reasonPlaceholder: 'e.g. Staffing constraints during this period',
      confirmReject: 'Confirm Reject',
      noBalances: 'No leave balances yet for this year.',
      allocated: 'Allocated',
      used: 'Used',
      pending: 'Pending',
      available: 'Available',
    },
    attendance: {
      title: 'Attendance',
      subtitle: 'Daily attendance overview',
      workDate: 'Work date',
      total: 'Records',
      totalHours: 'Total hours',
      overtimeHours: 'Overtime hours',
      present: 'Present',
      employee: 'Employee',
      clockIn: 'Clock-in',
      clockOut: 'Clock-out',
      hours: 'Hours',
      overtime: 'Overtime',
      statusCol: 'Status',
      empty: 'No attendance records for this date',
      openDashboard: 'Open the Attendance Dashboard for full records.',
    },
    documents: {
      empty: 'No documents uploaded yet',
      expires: 'Expires',
    },
    contracts: {
      empty: 'No contracts yet',
    },
    tabs: {
      profile: 'Profile',
      documents: 'Documents',
      contracts: 'Contracts',
      attendance: 'Attendance',
      leave: 'Leave',
    },
    fields: {
      nationality: 'Nationality',
      emiratesId: 'Emirates ID',
      passportNo: 'Passport No.',
      dob: 'Date of Birth',
      gender: 'Gender',
      maritalStatus: 'Marital Status',
      hireDate: 'Hire Date',
      terminationDate: 'Termination Date',
      contactEmail: 'Email',
      contactPhone: 'Phone',
      startDate: 'Start date',
      endDate: 'End date',
      basicSalary: 'Basic salary',
      workingHours: 'Working hours',
    },
    employmentStatus: {
      active: 'Active',
      on_leave: 'On leave',
      suspended: 'Suspended',
      terminated: 'Terminated',
      resigned: 'Resigned',
    },
    gender: {
      male: 'Male',
      female: 'Female',
    },
    maritalStatus: {
      single: 'Single',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
    },
    contractType: {
      unlimited: 'Unlimited',
      limited: 'Limited',
      part_time: 'Part-time',
      temporary: 'Temporary',
    },
    contractStatus: {
      draft: 'Draft',
      active: 'Active',
      expired: 'Expired',
      terminated: 'Terminated',
    },
    documentType: {
      emirates_id: 'Emirates ID',
      passport: 'Passport',
      visa: 'Visa',
      work_permit: 'Work permit',
      labour_card: 'Labour card',
      education: 'Education',
      health_insurance: 'Health insurance',
      other: 'Other',
    },
    leaveStatus: {
      draft: 'Draft',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    attendanceStatus: {
      present: 'Present',
      absent: 'Absent',
      half_day: 'Half day',
      on_leave: 'On leave',
      holiday: 'Holiday',
      weekend: 'Weekend',
    },
  },

  payroll: {
    periods: {
      title: 'Payroll Periods',
      count: '{{count}} period(s)',
      new: 'New Period',
      newTitle: 'New Payroll Period',
      year: 'Year',
      month: 'Month',
      empty: 'No payroll periods yet',
      emptyHint: 'Create your first payroll period to begin.',
      createFailed: 'Could not create period (duplicate or validation error).',
    },
    runs: {
      backToPeriods: 'Back to periods',
      headerTitle: 'Payroll {{year}}-{{month}}',
      step: 'Step',
      steps: {
        review: 'Review',
        calculate: 'Calculate',
        post: 'Post',
        wps: 'WPS Export',
      },
      reviewTitle: 'Ready to begin',
      reviewHint: 'Initiate a payroll run for this period.',
      initiate: 'Initiate Run',
      calculateTitle: 'Calculate payslips',
      calculateHint: 'Run the calculator against all active employees.',
      calculate: 'Calculate',
      calculating: 'Calculating…',
      recalculate: 'Recalculate',
      post: 'Post Run',
      openWps: 'Open WPS Export',
      employee: 'Employee',
      basic: 'Basic',
      allowances: 'Allowances',
      overtime: 'Overtime',
      deductions: 'Deductions',
      net: 'Net',
      totalGross: 'Total Gross',
      totalDeductions: 'Total Deductions',
      totalGOSI: 'Total GOSI',
      totalNet: 'Total Net',
    },
    payslip: {
      title: 'Payslip',
      runEmployee: 'Run #{{run}} · Employee #{{employee}}',
      downloadPdf: 'Download PDF',
      earnings: 'Earnings',
      deductions: 'Deductions',
      basic: 'Basic salary',
      allowances: 'Allowances',
      overtime: 'Overtime',
      gross: 'Gross pay',
      gosi: 'GOSI',
      totalDeductions: 'Total deductions',
      netPay: 'Net pay',
    },
    wps: {
      title: 'WPS SIF Export',
      subtitle: 'Generate UAE Wages Protection System files for bank submission.',
      generateTitle: 'Generate new SIF',
      submitterCode: 'Submitter code',
      employerId: 'Employer ID',
      bankCode: 'Bank code',
      paymentDate: 'Payment date',
      generate: 'Generate SIF',
      generateFailed: 'Generation failed. The run must be POSTED first.',
      empty: 'No WPS batches yet for this run.',
      batch: 'Batch',
      submit: 'Submit to bank',
      accept: 'Mark accepted',
    },
    gratuity: {
      title: 'Gratuity Calculator',
      subtitle: 'End-of-service settlement per UAE Federal Decree-Law 33/2021.',
      employeeId: 'Employee ID',
      reason: 'Reason',
      serviceEnd: 'Service end',
      basicSalary: 'Basic salary',
      useContractDefault: 'Defaults to active contract salary',
      priorDeductions: 'Prior deductions',
      calculate: 'Calculate',
      calcFailed: 'Calculation failed.',
      resultTitle: 'Calculation result',
      yearsOfService: 'Years of service',
      dailyWage: 'Daily wage',
      first5Days: 'First-5-years days',
      after5Days: 'After-5-years days',
      capApplied: 'Article 54 two-year cap applied ({{cap}} AED)',
      totalGratuity: 'Total gratuity',
    },
    periodStatus: {
      draft: 'Draft',
      locked: 'Locked',
      posted: 'Posted',
      cancelled: 'Cancelled',
    },
    runStatus: {
      pending: 'Pending',
      calculating: 'Calculating',
      calculated: 'Calculated',
      failed: 'Failed',
      posted: 'Posted',
    },
    wpsStatus: {
      generated: 'Generated',
      submitted: 'Submitted',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
    gratuityReason: {
      termination: 'Termination',
      resignation: 'Resignation',
      end_of_contract: 'End of contract',
      death: 'Death',
      disability: 'Disability',
    },
  },
  // === AGENT_A (M2.8 Workforce + Payroll) END ===

  // === AGENT_I (Frontend Set 2) BEGIN ===
  boqWizard: {
    title: 'BOQ Importer Wizard',
    subtitle: 'Guided steps to upload a BOQ and apply it to the project',
    step1: 'Step 1: Project',
    step2: 'Step 2: Upload file',
    step3: 'Step 3: Consultant template',
    step4: 'Step 4: Column mapping',
    step5: 'Step 5: Items preview',
    step6: 'Step 6: Apply',
    apply: 'Apply',
    next: 'Next',
    back: 'Back',
  },
  letters: {
    inbox: 'Formal Letters',
    new: 'New letter',
    subject: 'Subject',
    recipient: 'Recipient',
    body: 'Body',
    direction: 'Direction',
    incoming: 'Incoming',
    outgoing: 'Outgoing',
  },
  security: {
    center: 'Security Center',
    twoFactor: 'Two-Factor Setup',
    auditLog: 'Audit Log',
    sessions: 'Active Sessions',
    policies: 'ABAC Policies',
    suggestions: 'AI Role Suggestions',
    anomalies: 'Anomaly Alerts',
    revoke: 'Revoke',
  },
  materials: {
    catalog: 'UAE Materials Catalog',
    requests: 'Material Requests',
    consumption: 'Material Consumption',
    theftAlerts: 'Material Theft Alerts',
  },
  sustainability: {
    nav: 'Sustainability',
    dashboard: 'Sustainability',
    certifications: 'Sustainability Certifications',
    carbon: 'Carbon Footprint',
    resources: 'Water & Electricity',
  },
  // === AGENT_I (Frontend Set 2) END ===

  // === STAGE4_P1H (Confidence visualization) BEGIN ===
  confidence: {
    level: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      veryLow: 'Very low',
    },
    meaning: {
      high: 'Very strong match — safe to accept without manual review.',
      medium: 'Reasonable match — quick spot-check is recommended.',
      low: 'Uncertain match — review the suggestion before accepting.',
      veryLow: 'Weak match — do not accept without verification.',
    },
    improve: {
      high: [
        'No action needed — confidence is already strong.',
      ],
      medium: [
        'Confirm the unit and quantity match the source document.',
        'Add this item to the catalog so future matches are stronger.',
      ],
      low: [
        'Add more keywords to the catalog entry.',
        'Provide an attachment (drawing, photo, spec sheet).',
        'Pick the correct catalog item manually to teach the model.',
      ],
      veryLow: [
        'The source data is sparse — enrich the description first.',
        'Check that the catalog actually contains this material.',
        'Manual review by an estimator is strongly recommended.',
      ],
    },
    tooltip: {
      meaning: 'What this means',
      improve: 'How to improve it',
      sources: 'Contributing sources',
      aiReasoning: 'AI reasoning',
    },
    aria: {
      badge: 'Confidence: {{level}}, {{pct}}',
      bar: 'Confidence bar: {{level}}, {{pct}}',
      circle: 'Confidence ring: {{level}}, {{pct}}',
    },
  },
  // === STAGE4_P1H (Confidence visualization) END ===

  // === STAGE4-P2E (Pricing UI) BEGIN ===
  pricing: {
    loading: 'Computing market price…',
    samples: 'samples',
    suggestion: {
      title: 'AI Price Suggestion',
      range: 'Suggested rate range',
    },
    range: {
      low: 'Low',
      avg: 'Avg',
      high: 'High',
    },
    confidence: {
      label: 'Confidence',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
    },
    trend: {
      rising: 'Rising',
      stable: 'Stable',
      falling: 'Falling',
      // The server's DEFAULT for market_trend, so the most likely value --
      // not an edge case. Saying 'Stable' for it would be a claim about the
      // market that nobody made.
      unknown: 'Trend unknown',
    },
    sources: {
      title: 'Sources breakdown',
      // `history` is the rate-history GRAPH's bucket (recorded rate events);
      // `historical` is the SUGGESTER's aggregated layer. Different concepts
      // from different endpoints, so both keys earn their place.
      history: 'Project history',
      historical: 'Our past rates',
      govt: 'Government data',
      crowd: 'Crowd pricing',
      ai: 'AI model',
    },
    actions: {
      accept: 'Accept suggestion',
      override: 'Override',
      overridePlaceholder: 'Custom rate',
      bulkApply: 'Apply suggested rates',
      bulkApplied: '{{applied}} rates applied · {{skipped}} skipped',
      rateUpdated: 'Rate updated',
    },
    history: {
      title: 'Rate history',
      period: 'Period',
      empty: 'No history yet',
      periods: {
        '1m': '1M',
        '3m': '3M',
        '6m': '6M',
        '1y': '1Y',
      },
    },
    error: {
      title: 'Price suggestion failed',
      generic: 'Could not load suggestion. Try again later.',
      history: 'Could not load rate history.',
    },
    market: {
      yourRate: 'Your rate',
      marketAvg: 'Market avg',
      variance: 'Variance',
      withinRange: 'Within market range',
      moderate: 'Moderate variance',
      outOfRange: 'Out of market range',
      unknown: 'No market data',
    },
    column: {
      aiSuggestion: 'AI Price',
      suggest: 'Suggest',
    },
    rateReview: {
      badge: 'Rate needs estimator review',
      replaced: 'Automatic rate since changed — its review is still open',
      setBy: 'Set automatically from the take-off ({{source}}) on {{date}}',
      clear: 'Mark reviewed',
      clearing: 'Saving…',
      cleared: 'Rate marked as reviewed',
      noPermission: 'Only a user who may set prices can mark this rate reviewed',
    },
    dashboard: {
      title: 'Pricing Dashboard',
      subtitle: 'Project cost overview vs market benchmarks',
      overview: 'Project overview',
      totalEstimated: 'Total estimated',
      marketAvg: 'Market average',
      varianceVsMarket: 'Variance vs market',
      varianceAlertTitle: 'Items flagged for variance',
      varianceAlertBody:
        '{{count}} items deviate from market by more than 15%.',
      categoryTrends: 'Cost trends by category',
      projectedVsActual: 'Projected vs actual',
      projected: 'Projected',
      actual: 'Actual',
      topExpensive: 'Top expensive items',
      items: 'items',
      backToBoq: 'Back to BOQ',
      loadError: 'Could not load pricing dashboard.',
    },
  },
  // === STAGE4-P2E END ===

  // === STAGE4-P5B (One-Click Generate UI) BEGIN ===
  qtoGenerate: {
    badge: 'New · Stage 4 Magic Flow',
    title: 'Generate BOQ + Pricing in one click',
    subtitle:
      'Pick your drawings, hit one button, and watch ORKSTRA do the eight hours of work that used to ruin your weekend.',
    stepper: {
      label: 'Wizard steps',
    },
    steps: {
      project: 'Project',
      specs: 'Specs',
      config: 'Config',
      review: 'Review',
      generate: 'Generate',
      progress: 'Progress',
      results: 'Results',
    },
    actions: {
      runAgain: 'Run again',
    },
    comparison: {
      title: 'Eight hours of work → five minutes of magic',
      body: 'Traditional QTO + pricing on a tower like this eats a senior estimator for a day. ORKSTRA does it before your coffee gets cold.',
      manualLabel: 'Manual',
      manualValue: '8 hours',
      orkstraLabel: 'ORKSTRA',
      orkstraValue: '5 minutes',
      tryDemo: 'Run on demo project',
      dismiss: 'Dismiss',
    },
    project: {
      title: 'Step 1 · Project & drawings',
      subtitle:
        'Pick the project this run belongs to and the drawings the AI should read.',
      name: 'Project name',
      namePlaceholder: 'e.g. Sheikh Zayed Tower',
      code: 'Project code',
      drawings: 'Drawings to include',
      tryDemoInline: 'Don\'t have a project? Try the live demo →',
    },
    specs: {
      title: 'Step 2 · Specs (optional)',
      subtitle:
        'Drop the project specifications PDF so the AI can match BOQ items to the right grade, finish and standard.',
      dropzone: 'Drag a PDF here or click to upload',
      optional: 'Optional — the pipeline still runs without specs.',
    },
    config: {
      title: 'Step 3 · Configuration',
      subtitle: 'Tell the pipeline how careful to be and where the bid is going.',
      criticality: 'Criticality',
      criticalityOptions: {
        simple: {
          title: 'Simple',
          caption: 'Repetitive scope — single-pass AI, fastest.',
        },
        complex: {
          title: 'Complex',
          caption: 'Multi-discipline — recommended for most tenders.',
        },
        critical: {
          title: 'Critical',
          caption: 'High-stakes bid — triple-AI verified takeoffs.',
        },
      },
      tenderBody: 'Target tender body',
      tenderBodyPlaceholder: 'Select tender body',
      currency: 'Currency',
    },
    review: {
      title: 'Step 4 · Review the pipeline',
      subtitle:
        'Last checkpoint before launch. Click any earlier step to edit.',
      pipelineSteps: 'Pipeline stages',
      demoIndicator: 'Demo project — runs on sample data, no real upload needed.',
    },
    generate: {
      title: 'Ready to generate',
      subtitle:
        'One click runs calibration, symbol detection, measurement, AI BOQ-matching, pricing and exports.',
      cta: 'Generate BOQ + Pricing',
      demoNote: 'Demo mode — results are pre-recorded for the marketing reel.',
    },
    pipeline: {
      calibrate: {
        label: 'Calibrating drawings…',
        caption: 'Reading the scale bar and locking the page coordinates.',
      },
      detect_symbols: {
        label: 'Detecting symbols…',
        caption: 'YOLO + multi-model AI sweeping every sheet.',
      },
      measure: {
        label: 'Measuring elements…',
        caption: 'Lengths, areas, volumes and counts auto-extracted.',
      },
      match_boq: {
        label: 'Matching BOQ items (AI)…',
        caption: 'Few-shot AI mapping each measurement to a priced item.',
      },
      apply_pricing: {
        label: 'Applying pricing…',
        caption: 'Regional rate cards + crowd benchmarks reconciled.',
      },
      generate_exports: {
        label: 'Generating exports…',
        caption: 'BOQ Excel, pricing PDF and audit trail.',
      },
    },
    progress: {
      title: 'Working the magic',
      runningCaption: 'About {{seconds}}s left — feel free to grab a coffee.',
      completeCaption: 'Done. Scroll down to see the result.',
      cancelledCaption: 'Cancelled. You can run it again any time.',
      errorCaption: 'Something went wrong. Try again or contact support.',
      cancel: 'Cancel run',
    },
    results: {
      title: 'Magic delivered',
      subtitle:
        'Your BOQ, measurements and pricing are ready. Review what the AI flagged below.',
      summary: 'Summary stats',
      measurements: 'Measurements',
      boqItems: 'BOQ items linked',
      totalCost: 'Total project cost',
      confidence: 'AI confidence breakdown',
      confidenceHigh: 'High (>95%)',
      confidenceMedium: 'Medium (80–95%)',
      confidenceLow: 'Low (<80%) — review',
      timeSaved: 'Time saved',
      timeSavedCaption: 'vs the manual 8h estimate.',
      aiCost: 'AI cost incurred',
      aiCostCaption: 'Pay-as-you-go inference.',
      viewBOQ: 'View BOQ',
      download: 'Download exports',
      continueReview: 'Continue to manual review',
    },
  },
  // === STAGE4-P5B (One-Click Generate UI) END ===

  // === AGENT_S4H (Asset / Equipment frontend) BEGIN ===
  equipment: {
    title: 'Equipment & Assets',
    subtitle: 'Register, GPS, maintenance, fuel and operating hours.',
    addAsset: 'Add equipment',
    searchPlaceholder: 'Search asset code, name, serial, model…',
    emptyState: 'No equipment matches the current filters.',
    assetCode: 'Asset code',
    name: 'Name',
    manufacturer: 'Manufacturer',
    model: 'Model',
    serialNumber: 'Serial',
    year: 'Year',
    purchaseCost: 'Purchase cost',
    location: 'Location',
    currentProject: 'Current project',
    notes: 'Notes',
    specifications: 'Specifications',
    shift: 'Shift',
    hours: 'Hours',
    project: 'Project',
    status: {
      all: 'All',
      active: 'Active',
      idle: 'Idle',
      in_maintenance: 'In maintenance',
      retired: 'Retired',
      lost: 'Lost',
    },
    nav: {
      gpsMap: 'GPS map',
      maintenance: 'Maintenance',
      fuel: 'Fuel',
      costAllocation: 'Cost allocation',
    },
    detail: {
      backToList: 'Back to register',
      notFound: 'Equipment not found',
      tabs: {
        overview: 'Overview',
        hours: 'Operating hours',
        fuel: 'Fuel',
        maintenance: 'Maintenance',
        qr: 'QR code',
      },
      recentHours: 'Recent operating hours',
      recentFuel: 'Recent fuel events',
      activeSchedules: 'Active maintenance schedules',
      maintenanceHistory: 'Maintenance history',
      noHours: 'No hours logged yet.',
      noFuel: 'No fuel events logged yet.',
      noSchedules: 'No maintenance schedules set.',
      noMaintenanceHistory: 'No maintenance records yet.',
    },
    gpsMap: {
      title: 'Equipment GPS map',
      subtitle: 'All equipment with a known location.',
      legend: 'Legend',
      empty: 'No equipment has GPS coordinates yet.',
    },
    maintenance: {
      title: 'Maintenance schedule',
      subtitle: 'Upcoming preventive + corrective maintenance.',
      overdue: 'Overdue',
      next7days: 'Next 7 days',
      totalUpcoming: 'Total upcoming',
      overdueList: 'Overdue items',
      daysOverdue: 'days overdue',
      calendarTitle: 'Calendar',
      type: 'Type',
      title2: 'Title',
      status: 'Status',
      totalCost: 'Total cost',
    },
    fuel: {
      title: 'Fuel tracking',
      subtitle: 'Refuel events, consumption and cost per asset.',
      addEvent: 'Log refuel',
      equipment: 'Equipment',
      type: 'Fuel type',
      liters: 'Litres',
      unitCost: 'Unit cost',
      totalCost: 'Total cost',
      totalLiters: 'Total litres',
      totalEvents: 'Total events',
      supplier: 'Supplier',
      consumptionByAsset: 'Consumption by asset',
      recent: 'Recent events',
      empty: 'No fuel events yet.',
      eventCount: 'Events',
      logged: 'Refuel logged',
    },
    utilization: {
      pct: 'Utilization %',
      hours: 'Hours',
      chartTitle: 'Utilization by asset',
      empty: 'No utilization data in the selected window.',
    },
    costAllocation: {
      title: 'Cost allocation',
      subtitle: 'Operating hours allocated per project.',
      projectFilter: 'Filter by project #',
      byProject: 'By project',
      noAllocation: 'No operating hours logged in this window.',
      activeAssets: 'Active assets',
      perAssetTitle: 'Per-asset breakdown for project',
      logCount: 'Log count',
    },
    qr: {
      title: 'Anti-theft QR sticker',
      print: 'Print sticker',
      downloadPng: 'Download PNG',
    },
  },
  // === AGENT_S4H (Asset / Equipment frontend) END ===

  // === AGENT_S4Q (AI Auto-Takeoff Phase 2) BEGIN ===
  autoTakeoff: {
    pageTitle: 'AI Auto-Takeoff',
    pageSubtitle: 'Upload a drawing -- AI detects walls, columns, beams, doors, windows, and rolls them up into a BOQ.',
    newJobTitle: 'New auto-takeoff job',
    drawingId: 'Drawing ID',
    projectId: 'Project ID',
    complexity: 'Complexity',
    complexitySimple: 'Simple (Gemini-only)',
    complexityComplex: 'Complex (Gemini + Claude)',
    complexityCritical: 'Critical (Triple-AI + review)',
    elementTypesLabel: 'Element types',
    detectAll: 'Detect everything',
    governmentToggle: 'Government / regulatory project (forces CRITICAL)',
    startJob: 'Start AI takeoff',
    startingJob: 'Starting…',
    jobsListTitle: 'Recent jobs',
    jobsEmpty: 'No auto-takeoff jobs yet.',
    job: 'Job',
    status: 'Status',
    detectionsCount: '{{count}} detections',
    confidenceAvg: 'Avg confidence',
    review: 'Review',
    deleteJob: 'Delete job',
    deleteConfirm: 'Delete this auto-takeoff job and all of its detections?',
    reviewTitle: 'Review AI detections',
    reviewSubtitle: 'Confidence-coded overlay -- click a rectangle to inspect.',
    autoAcceptThreshold: 'Auto-accept threshold',
    acceptAll: 'Accept all above threshold',
    accepting: 'Accepting…',
    acceptResult: 'Accepted {{accepted}} · Skipped {{skipped}}',
    pending: 'Pending review',
    accepted: 'Accepted',
    overlayCaption: 'Detections overlay',
    sidePanelTitle: 'Detection details',
    sidePanelEmpty: 'Click a detection on the overlay to inspect it.',
    elementType: 'Element type',
    // NOTE: `confidence` is declared again below as an OBJECT
    // (low/medium/high) and JS keeps the last duplicate, so a string
    // here was already dead -- and TS1117 blocked the type gate the
    // moment this file appeared in a PR's changed-file list.
    layer: 'Layer',
    page: 'Page',
    dimensions: 'Dimensions',
    rejectDetection: 'Reject detection',
    rejectConfirm: 'Reject this detection? It will not be applied to the BOQ.',
    applyEdits: 'Save edits',
    edit: 'Edit',
    cancelEdit: 'Cancel',
    correctionSaved: 'Correction recorded -- learning loop updated.',
    correctionError: 'Could not save the correction.',
    filterByType: 'Filter by type',
    filterAll: 'All',
    reviewedOnly: 'Reviewed only',
    pendingOnly: 'Pending only',
    elements: {
      wall: 'Wall',
      column: 'Column',
      beam: 'Beam',
      slab: 'Slab',
      door: 'Door',
      window: 'Window',
      area: 'Area',
      stairs: 'Stairs',
    },
    confidence_levels: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    confidence: {
      high: 'High confidence',
      medium: 'Medium confidence',
      low: 'Low confidence (CRITICAL)',
    },
    rollups: {
      title: 'Quantity rollups',
      element: 'Element',
      count: 'Count',
      length: 'Length (m)',
      area: 'Area (m²)',
      volume: 'Volume (m³)',
      unit: 'Unit',
      empty: 'No rollups yet -- run the job to populate quantities.',
    },
    boq: {
      title: 'BOQ suggestions',
      subtitle: 'Apply accepted detections to a BOQ section on the linked project.',
      apply: 'Apply to BOQ',
      applying: 'Applying…',
      applied: 'Applied',
      empty: 'No accepted detections yet -- review the overlay above.',
      bomMatched: 'Matched BOM #{{id}}',
      bomMissing: 'No BOM match yet',
    },
  },
  // === AGENT_S4Q (AI Auto-Takeoff Phase 2) END ===

  // === ACCOUNTING-COA-VIEW-01 BEGIN ===
  chartOfAccounts: {
    title: 'Chart of Accounts',
    subtitle: "The tenant's general-ledger account structure (read-only)",
    search: 'Search by code or name…',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    code: 'Code',
    name: 'Name',
    type: 'Type',
    inactive: 'Inactive',
    accountCount: '{{count}} accounts',
    empty: 'No accounts found',
    noMatch: 'No accounts match your search',
    error: 'Could not load the chart of accounts',
  },
  // === ACCOUNTING-COA-VIEW-01 END ===

  // === ACCOUNTING-GL-LEDGER-01 BEGIN ===
  accountLedger: {
    title: 'Account Ledger',
    subtitle: 'Posted entry lines for a single account over a period range (read-only)',
    account: 'Account',
    selectAccount: 'Select an account…',
    fiscalYear: 'Fiscal Year',
    periodFrom: 'From period',
    periodTo: 'To period',
    wholeYear: 'Whole year',
    date: 'Date',
    entry: 'Entry',
    description: 'Description',
    debit: 'Debit',
    credit: 'Credit',
    runningBalance: 'Running balance',
    openingBalance: 'Opening balance',
    closingBalance: 'Closing balance',
    totals: 'Totals',
    choosePrompt: 'Choose an account and a fiscal year to view its ledger.',
    empty: 'No posted lines for this account in the selected period.',
    error: 'Could not load the account ledger',
  },
  // === ACCOUNTING-GL-LEDGER-01 END ===

  // === B29 Lane A: permission-aware UI (UI-PERM-GUARDS-01 / PERM-DENIED-AR-01) ===
  // {{reason}} is the bilingual sentence from lib/permissionLabels.ts
  // (e.g. "Requires invoice approval permission (senior accountant)").
  rbac: {
    requiresPermission: '{{reason}}',
    deniedAction: 'You do not have permission for this action',
  },
}
